export const DEFAULT_INFIELD_LANGUAGE = 'NA';
export const DEFAULT_INFIELD_LANGUAGE_OPTIONS = ['Hindi', 'English'];
export const CREATE_INFIELD_LANGUAGE_VALUE = '__create_infield_language__';

export function normalizeInfieldLanguageName(value) {
  const text = String(value || '').trim();
  if (!text) return DEFAULT_INFIELD_LANGUAGE;
  if (text.toLowerCase() === DEFAULT_INFIELD_LANGUAGE.toLowerCase()) {
    return DEFAULT_INFIELD_LANGUAGE;
  }
  return text;
}

export function normalizeInfieldLanguageOptions(values = []) {
  const merged = [
    ...DEFAULT_INFIELD_LANGUAGE_OPTIONS,
    ...(Array.isArray(values) ? values : []),
  ];
  const seen = new Set();
  const normalized = [];

  merged.forEach((value) => {
    const item = String(value || '').trim();
    if (!item) return;
    const key = item.toLowerCase();
    if (key === DEFAULT_INFIELD_LANGUAGE.toLowerCase() || seen.has(key)) return;
    seen.add(key);
    normalized.push(item);
  });

  return normalized;
}

export function canDeleteInfieldLanguage(value) {
  const normalized = String(value || '').trim().toLowerCase();
  return Boolean(normalized) && !DEFAULT_INFIELD_LANGUAGE_OPTIONS.some(
    (item) => item.toLowerCase() === normalized
  );
}
